import { FC } from 'react'

import AreaCardComponent from 'components/cards/AreaCard'
import type { Facility } from 'features/facility/types/facility'

import styles from './FacilityCardList.module.scss'

type Props = {
  facilities: Facility[]
  countrySlug: string
  citySlug: string
  localePath: string
}

const FacilityCardList: FC<Props> = ({
  facilities,
  countrySlug,
  citySlug,
  localePath,
}: Props): JSX.Element => {
  return (
    <ul className={styles.list}>
      {facilities.map((facility) => {
        const href = `/${localePath}/${countrySlug}/city/${citySlug}/${facility.id}`

        return (
          <li className={styles.listItem} key={facility.id}>
            <AreaCardComponent
              name={facility.name}
              href={href}
              imageUrl={facility.image_url ?? undefined}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default FacilityCardList
